"use client"

import { PreferredLanguage } from "@/models/enum"
import { createContext, useContext, useState, ReactNode } from "react"

interface LanguageContextType {
  language: PreferredLanguage
  setLanguage: (lang: PreferredLanguage) => void
}

const LanguageContext = createContext<LanguageContextType | null>(null)

export function LanguageProvider({ children }: { children: ReactNode }) {
  const [language, setLanguage] = useState<PreferredLanguage>(PreferredLanguage.English)

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  )
}

export function useLanguage() {
  const context = useContext(LanguageContext)
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider")
  }
  return context
} 